/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/* @jsx jsx */

import { jsx } from '@emotion/react'
import { Fragment } from 'react'
import { noop } from 'lodash'

import { EuiFlexGroup, EuiPageHeader, EuiSpacer } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import Breadcrumbs from '@modules/cui/Breadcrumbs'
import { connectedClustersURL } from '@modules/ccm-user-lib/urls'

import AutoOpsFeatureCard from './AutoOpsFeatureCard'
import ElasticInferenceServiceCard from './ElasticInferenceServiceCard'

const PAGE_BREADCRUMBS = [
  {
    text: (
      <FormattedMessage
        id='ccm.feature-selector.breadcrumbs.cloud-connected-services'
        defaultMessage='Cloud Connected Services'
      />
    ),
    to: connectedClustersURL(),
  },
  {
    text: (
      <FormattedMessage id='ccm.feature-selector.breadcrumbs.services' defaultMessage='Services' />
    ),
    to: connectedClustersURL(),
  },
]

const CCMFeatureSelectorScreen = () => (
  <Fragment>
    <Breadcrumbs breadcrumbs={PAGE_BREADCRUMBS} />

    <EuiPageHeader
      bottomBorder={true}
      pageTitle={
        <FormattedMessage
          id='ccm.feature-selector.title'
          defaultMessage='Cloud Connected Services'
        />
      }
      description={
        <FormattedMessage
          id='ccm.feature-selector.description'
          defaultMessage='Elastic Cloud Connected allows customers running self-managed Elastic Software to access
            Elastic capabilities as a cloud service without the operational overhead of managing the infrastructure
            required to run.'
        />
      }
    />
    <EuiFlexGroup direction='column' justifyContent='center' alignItems='center'>
      <EuiSpacer size='xxl' />
      <EuiFlexGroup>
        {/* TODO: https://github.com/elastic/cloud/issues/142674 wire up real actions to these card buttons */}
        <AutoOpsFeatureCard onNext={noop} />
        <ElasticInferenceServiceCard onNext={noop} />
      </EuiFlexGroup>
    </EuiFlexGroup>
  </Fragment>
)

export default CCMFeatureSelectorScreen
